(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name home.controller:HomeCtrl
     *
     * @description
     *
     */
    angular
        .module('home')
        .controller('HomeCtrl', HomeCtrl);

    function HomeCtrl(ApplicationService, TabService) {
        var vm = this;
        vm.userInfo = ApplicationService.getLoginInfo();
        TabService.addTab('home');
        vm.onMenuClick = function (path) {
            TabService.gotoTab(path);
        };

        vm.menuClickForWindow = function (path) {
            TabService.gotoTab(path, null, 'popup');
        };

        vm.tab = 1;
        vm.tabClick = function (tabID) {
            vm.tab = tabID
        }
    }


}());
